<script setup lang="ts">
import BaseButtonSecondary from '../../../base/BaseButtonSecondary.vue'
import BaseInputText from '../../../base/BaseInputText.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { onMounted, ref } from 'vue'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'

const props = defineProps<{
    profileType: 'natural' | 'legal'
}>()

const personalAccountStore = usePersonalAccountDataState()
const legalAccountStore = useLegalAccountDataState()
const form = ref({ depot_owner: '', depot_number: '', depot_bank: '', depot_bic: '' })

const submit = async () => {
    if (props.profileType === 'natural') {
        personalAccountStore.naturalProfile.depot_owner = form.value.depot_owner
        personalAccountStore.naturalProfile.depot_number = form.value.depot_number
        personalAccountStore.naturalProfile.depot_bank = form.value.depot_bank
        personalAccountStore.naturalProfile.depot_bic = form.value.depot_bic
        await personalAccountStore.saveAccountData()
    } else {
        legalAccountStore.legalProfile.depot_owner = form.value.depot_owner
        legalAccountStore.legalProfile.depot_number = form.value.depot_number
        legalAccountStore.legalProfile.depot_bank = form.value.depot_bank
        legalAccountStore.legalProfile.depot_bic = form.value.depot_bic
        await legalAccountStore.saveAccountData()
    }
}

onMounted(() => {
    if (props.profileType === 'natural') {
        form.value.depot_owner = personalAccountStore.naturalProfile.depot_owner
        form.value.depot_number = personalAccountStore.naturalProfile.depot_number
        form.value.depot_bank = personalAccountStore.naturalProfile.depot_bank
        form.value.depot_bic = personalAccountStore.naturalProfile.depot_bic
    } else {
        form.value.depot_owner = legalAccountStore.legalProfile.depot_owner
        form.value.depot_number = legalAccountStore.legalProfile.depot_number
        form.value.depot_bank = legalAccountStore.legalProfile.depot_bank
        form.value.depot_bic = legalAccountStore.legalProfile.depot_bic
    }
})
</script>

<template>
    <div class="grid h-auto w-full grid-cols-2 gap-6">
        <div class="col-span-1">
            <BaseInputText
                v-model="form.depot_owner"
                name="depot_owner"
                :label="$t('investment_process.depot_owner')" />
        </div>
        <div class="col-span-1">
            <BaseInputText
                v-model="form.depot_number"
                name="depot_number"
                :label="$t('investment_process.depot_number')" />
        </div>
        <div class="col-span-1">
            <BaseInputText v-model="form.depot_bank" name="depot_bank" :label="$t('investment_process.depot_bank')" />
        </div>
        <div class="col-span-1">
            <BaseInputText v-model="form.depot_bic" name="depot_bic" :label="$t('investment_process.depot_bic')" />
        </div>
    </div>
    <div class="mt-6 flex h-auto w-full items-center justify-end">
        <BaseButtonSecondary @click="submit">{{ $t('save') }}</BaseButtonSecondary>
    </div>
</template>
